import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

export const Profile = styled(GatsbyImage)`
  Img {
    //padding: 2px;
    //margin: 5px;
    //height: 260px;
    //width: 222px;
    height: 90%;
    width: 90%;
    border: 2px solid lightblue;
    //aspect-ratio: auto;
    //box-shadow: red 5px;
  }
`
